import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/opt/homebrew/lib/node_modules/workbox-cli/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "js/bootstrap.js",
    "revision": "7536229d93d7ba2ef1620b8a14fc32a5"
  },
  {
    "url": "js/main.js",
    "revision": "a8d40469d3d72ab4b11059362f3dd825"
  },
  {
    "url": "js/app.min.js",
    "revision": "8570138b465673952368f1406dd5a4de"
  },
  {
    "url": "js/extensions.min.js",
    "revision": "65998885ad5af2f6a14315f3cd9e4d4c"
  },
  {
    "url": "js/orgchart.min.js",
    "revision": "619d8c4dab47b81868916df31f55478b"
  },
  {
    "url": "js/stencils.min.js",
    "revision": "2932a9b572ced97336764408a2266f79"
  },
  {
    "url": "js/shapes-14-6-5.min.js",
    "revision": "04c8d9b709f15514592b337ad33aad74"
  },
  {
    "url": "js/math-print.js",
    "revision": "2906865fa4f7824eab9b648a6888db80"
  },
  {
    "url": "index.html",
    "revision": "9de11c65ec13b24c73ace7042bc529cc"
  },
  {
    "url": "styles/grapheditor.css",
    "revision": "23cbac10c03279392888893b3f694007"
  },
  {
    "url": "styles/high-contrast.css",
    "revision": "4ecc9f6d08787a9e2d29dacf7aadd1ca"
  },
  {
    "url": "js/dropbox/Dropbox-sdk.min.js",
    "revision": "4b9842892aa37b156db0a8364b7a83b0"
  },
  {
    "url": "js/onedrive/OneDrive.js",
    "revision": "e863f5e6833892f22492211663e3efe9"
  },
  {
    "url": "js/viewer-static.min.js",
    "revision": "dfcebfbe5a5478e2052d1fd421d4f396"
  },
  {
    "url": "resources/dia.txt",
    "revision": "66fe818e43b096f060797233ac192e69"
  },
  {
    "url": "mxgraph/css/common.css",
    "revision": "81d1704d5ab9207e2e5c7fc84379dc1a"
  }
], {
  "ignoreURLParametersMatching": [/.*/]
});








